import React, { useEffect, useState } from "react";
import LockerDetailsComponent from "../components/LockerDetailsComponent";
import DateTimeSelector from "../components/DateTimeSelector";
import { useHistory } from "react-router-dom";
import { AdvanceBookingLockerBankDetails } from "../api/api";
import BookingSummary from "../components/BookingSummary";
import ButtonComponent from "../components/ButtonComponent";
import LockerDurationDialog from "../components/LockerDurationDialog";
import { storeSecureItemInSpecifiedStorage } from "../lib/BrowserStorageAccessMiddleware";
import { ADVANCE_BOOKING, LOCAL_STORAGE, LS_BOOKING_TYPE } from "../assets/constants/BrowserStorageKeys";
import { useTranslation } from "react-i18next";
import { getPathForNextPage } from "../lib/Utils";
import { LOCKER_DETAILS, LOCKER_SIZE_SELECTION } from "../assets/constants/PageList";
import ShowToast from "../components/ToastComponent";
import { TOAST_ERROR } from "../assets/constants/Constants";

export default function LockerDetailsPage() {
  const history = useHistory();
  const { t } = useTranslation();
  const { lockerDetails } = history.location?.state || {};
  const [showDateTimeSelector, setShowDateTimeSelector] = useState(false);


  const handleBookStore = () => {
    setShowDateTimeSelector(true);

    // Scroll to DateTimeSelector smoothly
    setTimeout(() => {
      document
        .querySelector(".locker-details-page__datetime-section")
        ?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
    }, 100);
  };

  const handleBackToDetails = () => {
    setShowDateTimeSelector(false);

    // Scroll back to top
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDateTimeContinue = async(dateTimeData) => {
    // Combine locker details + datetime
    const bookingData = {
        locker: lockerDetails,
        ...dateTimeData,
    };
  const requestData = {
    lockerBankId: lockerDetails?.id,
    reserve_start: bookingData?.reserve_start,
    reserve_end: bookingData?.reserve_end
  };

    let response;
    try {
      response = await AdvanceBookingLockerBankDetails(requestData);
    } catch (error) {
      console.error("AdvanceBookingLockerBankDetails error:", error);
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "error_msg_something_went_wrong_try_again";
      ShowToast(t(message), TOAST_ERROR);
      return false;
    }

    if (!response?.data?.data) {
      ShowToast(t("error_msg_something_went_wrong_try_again"), TOAST_ERROR);
      return false;
    }

    const advacnelockerResponse = response?.data?.data;

    const tempdata = {
        lockerBankId: advacnelockerResponse?.id,
        bookingTimingObject: {
          ...dateTimeData
        },
        assignmentSlug: advacnelockerResponse?.locker_assignments[0]?.slug,
        locker_bank_slug:advacnelockerResponse?.slug,
        userId: null,
        availableLockerSizes: advacnelockerResponse?.door_sizes || [],
        isManualLockerSelectionEnabled: advacnelockerResponse?.isManualLockerSelectionEnabled,
        IsAdvanceBooking: true,
        address: advacnelockerResponse?.address_line1 ? advacnelockerResponse?.address_line1 : advacnelockerResponse?.address_line2,
        lockerCurrency: advacnelockerResponse?.locker_assignments[0]?.currency,  
    };
    storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_BOOKING_TYPE, ADVANCE_BOOKING )

    history.push({
        pathname: getPathForNextPage(LOCKER_DETAILS, LOCKER_SIZE_SELECTION),
        state: { ...tempdata }
    });

    return true;
  };

  if (!lockerDetails) {
    return (
      <div className="locker-details-page">
        <div className="locker-details-page__error">
          <h2>{t("no_locker_details_found_title")}</h2>
          <p>{t("go_back_select_locker_text")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="locker-details-page">
        {/* Conditional Rendering */}
        {!showDateTimeSelector ? (
          <div className="locker-details-container">
            <LockerDetailsComponent
              locker={lockerDetails}
              onBook={handleBookStore}
            />
          </div>
        ) : (
          <div className="locker-datetime-picker-container">
            <DateTimeSelector onContinue={handleDateTimeContinue} />
          </div>
        )}
       
       
      </div>
  );
}
